// extracted by mini-css-extract-plugin
export default {"table":"CustomTable_table__fntxI"};